// src/components/TrustBar.jsx
import { Cloud, Lock, ShieldCheck } from "lucide-react";
import AppExchangeBadge from "../assets/sf-appexchange-badge.png";

const Chip = ({ icon: Icon, children }) => (
  <span className="inline-flex items-center gap-2 rounded-full bg-white/85 backdrop-blur px-3 py-1.5 text-sm text-slate-700 ring-1 ring-black/5 shadow-sm">
    <Icon className="h-4 w-4" aria-hidden="true" />
    {children}
  </span>
);

export default function TrustBar({ appexListingUrl = "" }) {
  return (
    <section className="py-14 bg-gradient-to-b from-orange-50/60 via-pink-50/40 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="text-slate-600">Trusted by Salesforce organizations worldwide</p>

        {/* AppExchange badge — NO border/container */}
        <div className="mt-6">
          {appexListingUrl ? (
            <a
              href={appexListingUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="View on Salesforce AppExchange"
            >
              <img
                src={AppExchangeBadge}
                alt="Salesforce AppExchange"
                className="mx-auto h-16 sm:h-20 w-auto select-none"
              />
            </a>
          ) : (
            <img
              src={AppExchangeBadge}
              alt="Salesforce AppExchange"
              className="mx-auto h-16 sm:h-20 w-auto select-none"
            />
          )}
        </div>

        {/* Chips */}
        <div className="mt-5 flex flex-wrap justify-center gap-3 sm:gap-4">
          <Chip icon={Cloud}>Enterprise-grade cloud</Chip>
          <Chip icon={Lock}>TLS encryption</Chip>
          <Chip icon={ShieldCheck}>Data stays in your Salesforce org*</Chip>
        </div>

        <p className="mt-4 text-xs text-slate-500">
          *Templates and generated files remain in your Salesforce org; processing is transient with no app-side retention.
        </p>
      </div>
    </section>
  );
}